<script>
import Swiper from 'swiper';
import { A11y, Keyboard } from 'swiper/modules';

export default {
    name: 'SeriesSelectorAnswers',
    props: {
        answers: { type: Array, required: true },
        steps: { type: Array, required: true },
        questionId: { type: Number, required: true }
    },
    emits: ['answer'],
    data() {
        return {
            swiper: null,
            isInvisible: false
        };
    },
    watch: {
        answers: {
            handler() {
                this.$nextTick(() => {
                    if (this.swiper) {
                        this.isInvisible = true;
                        this.swiper.update();
                        this.swiper.slideTo(0, 0);
                        setTimeout(() => this.isInvisible = false, 100);
                    }
                });
            },
            deep: true
        }
    },
    mounted() {
        this.initSwiper();
    },
    beforeDestroy() {
        if (this.swiper) {
            this.swiper.destroy();
            this.swiper = null;
        }
    },
    methods: {
        initSwiper() {
            this.$nextTick(() => {
                if (this.$refs.seriesSelectorAnswerOptionsSlider) {
                    this.swiper = new Swiper(this.$refs.seriesSelectorAnswerOptionsSlider, {
                        modules: [A11y, Keyboard],
                        direction: 'horizontal',
                        speed: 500,
                        slidesPerView: 1.1,
                        spaceBetween: 16,
                        breakpoints: {
                            325: {
                                slidesPerView: 1.2,
                            },
                            360: {
                                slidesPerView: 1.4,
                            },
                            576: {
                                slidesPerView: 2.5,
                            },
                            768: {
                                slidesPerView: 3.5,
                            },
                            992: {
                                slidesPerView: 4.5,
                            },
                        },
                        keyboard: true,
                        a11y: true,
                        observer: true,
                        observeParents: true,
                        observeSlideChildren: true,
                    });
                }
            });
        },
        selectAnswer(answer) {
            this.clearSelectedStatusForAllAnswers();
            this.$emit('answer', answer);
        },
        clearSelectedStatusForAllAnswers() {
            for (const listElement of Array.from(this.$refs.answersListElement.children)) {
                listElement.firstElementChild.checked = false;
            }
        }
    }
};
</script>

<template>
    <div class="options" :class="{ 'invisible': isInvisible }">
        <fieldset ref="seriesSelectorAnswerOptionsSlider" class="swiper">
            <ul ref="answersListElement" class="swiper-wrapper">
                <li v-for="answer in answers" :key="answer.id" class="option swiper-slide">
                    <input
                        :id="answer.id"
                        type="radio"
                        name="options"
                        :value="answer.id"
                        @change="selectAnswer(answer)"
                    />
                    <label
                        :for="answer.id"
                        class="d-flex align-items-end p-3"
                    >
                        <span class="option__img" :style="`background-image: url(${answer.imageUrl})`"></span>
                        <span class="title" data-test="answer-title">{{ answer.name }}</span>
                    </label>
                </li>
            </ul>
        </fieldset>
    </div>
</template>